import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class OperatorListService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }

  getPreAccounts(cnpj?: string): Observable<any> {
    let queryParams = new HttpParams();

    const cleanCnpj = (cnpj || '').replace(/\D/g, '');
    if (cleanCnpj) {
      queryParams = queryParams.append('cnpj', cleanCnpj);
    }

    return this.http.get<any>(this.url('/account/preaccount'), {
      params: queryParams,
    });
  }

  getProductRegistration(pageSize: number, page: number): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('pageSize', pageSize);
    queryParams = queryParams.append('page', page);

    return this.http.get<any>(this.url('/product-registration'), {
      params: queryParams,
    });
  }

  getEnum(): Promise<any> {
    const origin = this.authService.getOriginCurrency();
    let queryParams = new HttpParams();
    queryParams = queryParams.append('origin', origin);

    return firstValueFrom(
      this.http.get<any>(`${environment.apiUrl}/enum`, { params: queryParams })
    );
  }

  exportPdf(filters?: { cnpj?: string }): Observable<any> {
    const payload: any = {};

    const cleanCnpj = (filters?.cnpj || '').replace(/\D/g, '');
    if (cleanCnpj) {
      payload.cnpj = cleanCnpj;
    }

    return this.http.post<any>(this.url('/reports/pre-accounts'), payload);
  }
}
